import { mergeClassnames } from '@heathmont/moon-core-tw';
import ItemText from '~/client/layout/Sidebar/SidebarItem/ItemText';
import Title from '~/client/layout/Sidebar/SidebarItem/Title';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  isHovered: boolean;
  text: string;
  description: string;
  descriptionColor?: string;
};

const ExtendedTitle: FC<Props> = ({
  isHovered,
  text,
  descriptionColor,
  description,
}) => (
  <div className="grid">
    <Title isHovered={isHovered} text={text} />
    <ItemText className={mergeClassnames('text-moon-12', descriptionColor)}>
      <Translate id={description} />
    </ItemText>
  </div>
);

export default ExtendedTitle;
